export default __webpack_public_path__ + "static/media/search.0ede1a90.svg";